module.exports = __webpack_public_path__ + "img/img_throw_3@2x_v2.68d3a083.png";